import React, {ReactElement} from "react"
import TitleBar from "../../components/TitleBar/TitleBar"
import {AllowedBillPayTermsColumns, BillPayTermsColumns} from "./BillPayTerms.types"
import {useAccessToken, useIsUnitUser} from "../../services/auth"
import {usePaging} from "../../hooks/usePaging"
import {findBillpayTerms} from "../../resources/billpayTerms"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"
import {DataTableCard, TablePending} from "../../components/DataTable/DataTable"
import BillPayTermsTable from "./BillPayTermsTable"
import {useNavigate} from "react-router-dom"
import Icon from "../../components/Icon/Icon"

const UNIT_USER_INCLUDED_COLUMNS: Array<AllowedBillPayTermsColumns> = [
	BillPayTermsColumns.id,
	BillPayTermsColumns.status,
	BillPayTermsColumns.org,
	BillPayTermsColumns.name,
	BillPayTermsColumns.createdAt,
]

export default function BillPayTermsList(): ReactElement {
	const navigate = useNavigate()
	const accessToken = useAccessToken()
	const isUnitUserBool = useIsUnitUser()

	const [result, hasPrev, hasNext, prev, next, hasResults] = usePaging(
		40,
		(offset, limit) => findBillpayTerms(accessToken, offset, limit),
		(x) => x.data.length,
		[],
		"",
		false,
		true
	)

	return (
		<DataTableCard className="billpay-terms-card">
			<TitleBar title="Bill Pay Terms">
				{isUnitUserBool && (
					<button className="button button-create" onClick={() => navigate("/billpay-terms/new")}>
						<Icon icon="interface-add-1" size={12} /> Create
					</button>
				)}
			</TitleBar>

			<AsyncResultComponent
				asyncResult={result}
				pendingComponent={<TablePending numberOfRows={UNIT_USER_INCLUDED_COLUMNS.length} />}
			>
				{({value: billpayTerms}) => (
					<BillPayTermsTable
						billpayTerms={billpayTerms.data}
						meta={billpayTerms.meta}
						hasResults={hasResults}
						hasPrev={hasPrev}
						hasNext={hasNext}
						prev={prev}
						next={next}
						isUsingPaging={true}
						include={billpayTerms.included}
						fullHeight={true}
						includedColumns={UNIT_USER_INCLUDED_COLUMNS}
					/>
				)}
			</AsyncResultComponent>
		</DataTableCard>
	)
}
